import React from 'react';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';
import useStyle from '../CarouselTags/carouselTags.style';
import { ProductCategory } from 'types/product/product';

export interface CarouselTagProps {
  tag: ProductCategory;
}

export const CarouselTag = ({ tag }: CarouselTagProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.descTag}>
        <FlatIcon icon={'LabelTag'} size="small" color="#FFFFFF" />
      </div>
      <div>{tag.name}</div>
    </div>
  );
};
